export const WAYPOINT_ROLE_START = 'start'
export const WAYPOINT_ROLE_FINISH = 'finish'
